import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({color = 'green', loaded = null}) => {
    return (
        <div style={{display: 'flex', width: '100%'}}>
            <div style={{display: 'flex', width: '100%'}}>
                <div style={styles.container}>
                    <div style={styles.fillerContainer}>
                        <div style={{
                            ...styles.topFiller,
                            backgroundColor: (color === 'green') ? '#29A499' : '#E42460',
                            width: ((loaded > 98) ? 98 : loaded) + '%',
                        }}/>
                        <div style={{
                            ...styles.bottomFiller,
                            backgroundColor: (color === 'green') ? '#228D83' : '#B11948',
                            width: ((loaded > 98) ? 98 : loaded) + '%',
                        }}/>
                        <div style={{...styles.outerBorder, border: (color === 'green' ? '4px solid #228D83' : '4px solid red')}}>
                            <div style={styles.innerBorder}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


Loader.propTypes = {
    color: PropTypes.string,
    loaded: PropTypes.number,
};

const config = {
    height: 40,
};

const styles = {
    container: {
        /*position: 'absolute',*/
        borderRadius: 25,
        height: config.height + 'px',
        width: '100%',
    },
    outerBorder: {
        display: 'flex',
        width: '100%',
        height: '100%',
        borderRadius: config.height / 2 + 'px',
        zIndex: 5,
    },
    innerBorder: {
        width: '100%',
        height: '100%',
        border: '4px solid black',
        borderRadius: config.height / 2,
    },
    fillerContainer: {
        backgroundColor: 'black',
        borderRadius: 25,
        display: 'flex',
        height: '100%',
        width: '100%',
        flexDirection: 'column',
        position: 'relative',
    },
    bottomFiller: {
        position: 'absolute',
        borderBottomLeftRadius: config.height / 2,
        borderBottomRightRadius: config.height / 2,
        top: config.height / 2,
        bottom: 4,
        left: 4,
        width: '0%',
    },
    topFiller: {
        position: 'absolute',
        borderTopLeftRadius: config.height / 2,
        borderTopRightRadius: config.height / 2,
        top: '4px',
        bottom: (config.height / 2) + 'px',
        left: '4px',
        width: '0%',
    },
};

export default Loader;
